import { useMemo } from "react";
import { Link, Navigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { ChevronLeft } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { CookiePreferencesPanel } from "../components/CookiePreferencesPanel";
import { privacyHtml } from "../legal/generated/privacyContent";
import { termsHtml } from "../legal/generated/termsContent";
import { cookiesHtml } from "../legal/generated/cookiesContent";

const PAGES = {
  privacidad: {
    title: "Política de privacidad",
    subtitle: "GABI IA · tratamiento de datos personales",
    html: privacyHtml,
  },
  terminos: {
    title: "Aviso legal",
    subtitle: "Condiciones de acceso y uso del sitio web",
    html: termsHtml,
  },
  cookies: {
    title: "Política de cookies",
    subtitle: "Uso de cookies y opciones de configuración",
    html: cookiesHtml,
  },
};

export const LegalDocumentPage = ({ routeKey }) => {
  const safeHtml = useMemo(() => {
    const cfg = PAGES[routeKey];
    if (!cfg) return "";
    return DOMPurify.sanitize(cfg.html, { USE_PROFILES: { html: true } });
  }, [routeKey]);

  const config = PAGES[routeKey];
  if (!config) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20 sm:pt-24 pb-12">
        <div className="container mx-auto px-4 max-w-3xl">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors mb-6"
          >
            <ChevronLeft className="w-4 h-4" aria-hidden />
            Volver al inicio
          </Link>

          <article className="rounded-3xl border border-border/60 bg-card/40 backdrop-blur-sm shadow-xl overflow-hidden">
            <header className="px-6 sm:px-10 pt-8 sm:pt-10 pb-6 border-b border-border/40 bg-gradient-to-br from-primary/5 to-accent/5">
              <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground">
                {config.title}
              </h1>
              <p className="mt-2 text-sm text-muted-foreground">{config.subtitle}</p>
            </header>
            {routeKey === "cookies" ? (
              <div className="px-6 sm:px-10 py-8 border-b border-border/40 bg-secondary/10">
                <CookiePreferencesPanel />
              </div>
            ) : null}
            <div
              className="px-6 sm:px-10 py-8 sm:py-10 prose prose-neutral dark:prose-invert max-w-none prose-headings:scroll-mt-24 prose-p:text-[15px] prose-p:leading-relaxed prose-li:marker:text-primary prose-a:text-primary prose-a:no-underline hover:prose-a:underline prose-strong:text-foreground"
              dangerouslySetInnerHTML={{ __html: safeHtml }}
            />
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};
